import { createSlice } from "@reduxjs/toolkit"

export const pupilProgressSlice = createSlice(
  {
    name: "pupilProgress",
    initialState: {
      pupilInfo: {},
      pupilFilter: {
        "info": {
          "EAL": false,
          "allEAL": true,
          "allPP": true,
          "classId": "All",
          "ehcp": true,
          "female": false,
          "male": false,
          "notEAL": false,
          "notPP": false,
          "notSen": true,
          "PP": false,
          "pupilYear": [1, 2, 3, 4, 5, 6],
          "sendSupport": true,
          "subjectName": "All",
          "unspecified": true
        },
        BPComparisonSelect: "None"
      },
      pupilSavedReport: {}
    },
    reducers: {
      setPupilInfo: (state, action) => {
        state.pupilInfo = action.payload
      },
      setPupilFilter: (state, action) => {
        state.pupilFilter = action.payload
      },
      setPupilSavedReport: (state, action) => {
        state.pupilSavedReport = action.payload
      },
      setPupilFilterInfo: (state, action) => {
        state.pupilFilter.info = action.payload
      },
      setBPComparisonSelect: (state, action) => {
        state.BPComparisonSelect = action.payload
      },
    },
  },

)

// Action creators are generated for each case reducer function
export const { setPupilInfo, setPupilFilter, setPupilSavedReport, setPupilFilterInfo, setBPComparisonSelect } = pupilProgressSlice.actions

export default pupilProgressSlice.reducer